<div class="loading">
    <cna-loading-spinner *ngIf="loading; else content"></cna-loading-spinner>
    <p *ngIf="loadingInfo" class="adelle-sans-17">{{ loadingInfo }}</p>
</div>
<ng-template #content>
    <ng-content></ng-content>
</ng-template>
